import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";
import { Toaster } from "./components/ui/sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import CustomOrder from "./pages/CustomOrder";
import CustomOrderSuccess from "./pages/CustomOrderSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import LegalPage from "./pages/LegalPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function PublicLayout({ children }) {
  return <><Header /><main>{children}</main><Footer /></>;
}

function AdminLayout({ children }) {
  return <>{children}</>;
}

function App() {
  return (
    <HelmetProvider>
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="min-h-screen bg-[#0A0A0A]">
              <Routes>
                <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                <Route path="/catalog" element={<PublicLayout><Catalog /></PublicLayout>} />
                <Route path="/product/:slug" element={<PublicLayout><ProductDetail /></PublicLayout>} />
                <Route path="/custom-order" element={<PublicLayout><CustomOrder /></PublicLayout>} />
                <Route path="/custom-order/success" element={<PublicLayout><CustomOrderSuccess /></PublicLayout>} />
                <Route path="/checkout/success" element={<PublicLayout><CheckoutSuccess /></PublicLayout>} />
                <Route path="/checkout/cancel" element={<PublicLayout><CheckoutCancel /></PublicLayout>} />
                <Route path="/impressum" element={<PublicLayout><LegalPage type="impressum" /></PublicLayout>} />
                <Route path="/datenschutz" element={<PublicLayout><LegalPage type="datenschutz" /></PublicLayout>} />
                <Route path="/agb" element={<PublicLayout><LegalPage type="agb" /></PublicLayout>} />
                <Route path="/widerruf" element={<PublicLayout><LegalPage type="widerruf" /></PublicLayout>} />
                <Route path="/admin/login" element={<AdminLayout><AdminLogin /></AdminLayout>} />
                <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
              </Routes>
              <Toaster position="top-right" />
            </div>
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </HelmetProvider>
  );
}

export default App;
